// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  UserStatus,
} from "./types";


export default __t.row({
  identity: __t.identity().primaryKey(),
  username: __t.string(),
  get status() {
    return UserStatus;
  },
  requestedAt: __t.timestamp().name("requested_at"),
  processedAt: __t.option(__t.timestamp()).name("processed_at"),
  processedBy: __t.option(__t.identity()).name("processed_by"),
});
